import {
  DebtSchema,
  Debt_InitialState,
  RadioSelect,
  RangeSlider,
  Select,
  TextArea,
  TextInput,
  debtTypeOptions,
  useOptions
} from "@fla/components";
import DebtIcon from "@fla/components/src/assets/svgs/debts.svg";
import { yupResolver } from "@hookform/resolvers/yup";
import { selectConsentOrdersBase } from "pages/ConsentOrders";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";

interface IProps {
  formId: string;
  store: Debt_InitialState;
  onSubmit: (values: Debt_InitialState) => void;
}
export default function Details({ formId, store, onSubmit }: IProps) {
  const { initialDetails } = useSelector(selectConsentOrdersBase);

  const { debtSplitByOptions, ownerV2Options } = useOptions({ initialDetails });

  const { handleSubmit, control, watch, setValue } = useForm({
    mode: "all",
    defaultValues: store,
    resolver: yupResolver(DebtSchema)
  });

  return (
    <form id={formId} className="space-y-5" onSubmit={handleSubmit(onSubmit)}>
      <div className="my-8 flex flex-col items-center justify-center">
        <img src={DebtIcon} className="w-10 h-auto my-3" alt="debts" />
        <h3 className="font-bold">Debts</h3>
      </div>

      <TextInput title="Describe the Debt" control={control} name="name" id="name" placeholder="Eg ATO Tax Debt" />

      <hr className="mt-7 mb-10 bg-gray-500 w-full" />
      <Select
        title="What type of debt is this"
        name="debt_type"
        id="debt_type"
        control={control}
        className="col-span-1"
        options={debtTypeOptions}
      />

      <hr className="mt-7 mb-10 bg-gray-500 w-full" />

      <Select
        title="In whose name is this debt in?"
        control={control}
        name="owner"
        id="owner"
        placeholder="Select"
        options={ownerV2Options}
      />

      <hr className="mt-7 mb-10 bg-gray-500 w-full" />

      <TextInput title="Outstanding Amount" control={control} name="value" id="value" isAmount />

      <hr className="mt-7 mb-10 bg-gray-500 w-full" />
      <RadioSelect
        title="What happens to this"
        type="card-brief"
        name="split_by"
        id="split_by"
        control={control}
        options={debtSplitByOptions as []}
        classes="my-8"
        onChange={v => {
          if (v === "percentage") {
            setValue("percentage", { user: "50", spouse: "50" });
          }
        }}
      />

      {watch("split_by") === "percentage" ? (
        <RangeSlider
          title="Split By Percentage"
          control={control}
          name="percentage.user"
          id="percentage.user"
          exName={initialDetails?.spouse?.first_name || "N/A"}
          percentageOf={watch("value")}
          onChange={val => {
            setValue("percentage.spouse", `${100 - Number(val)}`);
          }}
        />
      ) : null}

      <TextArea
        title="Further comments you want us to know about this (optional)"
        control={control}
        name="comment"
        id="comment"
        placeholder="Description"
      />
    </form>
  );
}
